// Elvix — scripts propios (vanilla JS, sin dependencias)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initAcordeon();
  initComparador();
});

function initReveal() {
  var els = document.querySelectorAll('.elx-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('elx-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-elx-delay') || 0;
          setTimeout(function () { entry.target.classList.add('elx-visible'); }, Number(delay));
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('.elx-num[data-target]');
  if (!els.length) return;
  var animated = new WeakSet();
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !animated.has(entry.target)) {
          animated.add(entry.target);
          animarNumero(entry.target);
        }
      });
    },
    { threshold: 0.6 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function animarNumero(el) {
  var target = parseFloat(el.getAttribute('data-target')) || 0;
  var suffix = el.getAttribute('data-suffix') || '';
  var decimals = target % 1 !== 0 ? 1 : 0;
  var duration = 1400;
  var start = null;
  function step(ts) {
    if (!start) start = ts;
    var progress = Math.min((ts - start) / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);
    var val = (target * eased).toFixed(decimals);
    el.textContent = val + suffix;
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

function initAcordeon() {
  var grupos = document.querySelectorAll('[data-elx-acordeon]');
  grupos.forEach(function (grupo) {
    var items = grupo.querySelectorAll('.elx-faq__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.elx-faq__pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('elx-faq__item--abierto');
        items.forEach(function (i) { i.classList.remove('elx-faq__item--abierto'); });
        if (!abierto) item.classList.add('elx-faq__item--abierto');
      });
    });
  });
}

function initComparador() {
  var wraps = document.querySelectorAll('[data-elx-comparador]');
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('.elx-comparador__handle');
    var after = wrap.querySelector('.elx-comparador__after');
    if (!handle || !after) return;
    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pos = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
      after.style.clipPath = 'inset(0 0 0 ' + (pos * 100) + '%)';
      handle.style.left = (pos * 100) + '%';
    }

    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointermove', function (e) {
      if (dragging) setPos(e.clientX);
    });
    handle.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('click', function (e) {
      if (e.target === handle) return;
      setPos(e.clientX);
    });
  });
}
